export type WaitAtLeast = {
  onStarted: () => void;
  onSucceeded: () => Promise<void>;
  onFailed: () => Promise<void>;
};

export default function useWaitAtLeast(
  minimumWaitTimeMS: number,
  onSucceeded: () => void,
  onFailed: () => void
): WaitAtLeast {
  let now = new Date().getTime();
  let timeout: NodeJS.Timeout | null = null;

  const onStarted = () => {
    now = new Date().getTime();
  };

  const onCompleted = (completedFn: () => void) => {
    return () => {
      if (timeout !== null) {
        clearTimeout(timeout);
      }

      const elapsed = new Date().getTime() - now;
      const minTimeToWait =
        elapsed < minimumWaitTimeMS ? minimumWaitTimeMS - elapsed : 0;

      if (minTimeToWait === 0) {
        completedFn();
        return Promise.resolve();
      }

      return new Promise<void>((res) => {
        timeout = setTimeout(() => {
          completedFn();
          res();
        }, minTimeToWait);
      });
    };
  };

  return {
    onStarted,
    onSucceeded: onCompleted(onSucceeded),
    onFailed: onCompleted(onFailed),
  };
}
